export const firebaseConfig = {
    apiKey: "AIzaSyC7ww28zhIW_Rn2t4Keggt6zRLnxpjLl1I",
    authDomain: "media-portfolio-d9047.firebaseapp.com",
    databaseURL: "https://media-portfolio-d9047.firebaseio.com",
    projectId: "media-portfolio-d9047",
    storageBucket: "media-portfolio-d9047.appspot.com",
    messagingSenderId: "524097930613",
    appId: "1:524097930613:web:c5f369d0f72e0fd41c7f3c",
    measurementId: "G-WLZRKLFB6G"
};